import React, { useState } from 'react';
import { useForm } from 'antd/lib/form/Form';
import { isEmpty, isNil } from 'lodash';
import {  Col } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { isBeneficiary } from 'utils';

import { SupplierEquipmentCosts, SupplierEquipmentInfo } from './components';
import { ApplicationStatusOverview, FormField } from 'components';
import { VoucherErrorBanner } from 'components/layout/components';
import  DownloadedVoucherItems from '../downloadedVoucherItems';
import { equipmentDocs } from './equipmentDocs';

const SupplierEquipmentForm = () => {
  const voucherAuditorComment = useSelector(state => state.forms?.supplier?.voucherInfo?.voucher?.voucherAuditorComment);
  const dispatch = useDispatch();
  const task = useSelector(state => state.forms.task);
  const [form] = useForm();
  const taskName = useSelector(state => state.forms.task.name);
  const user = useSelector(state => state.user);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const disableInLoading = useSelector(state => state.forms.disableInLoading);
  const viewMode = isViewMode || !isBeneficiary(user.groups);
  const supplierError = useSelector(state => state.forms?.supplier?.error);
  const voucherInfo = useSelector(state => state.forms?.supplier?.voucherInfo);
  const activeTaskName = useSelector(state => state.forms?.activeTaskName);
  const businessKey = useSelector(state => state.forms?.businessKey);
  const disableVoucherTabs = disableInLoading ||
                             voucherInfo?.responseCode !== "600" ||
                             voucherInfo?.voucher?.status !== "AVAILABLE";
  const [disableAction, setDisableAction] = useState(true);
  const [simulation, setSimulation] = useState(false);
  
  return (
    <div style={{ maxWidth: '95%', margin: 'auto'}}>
      {supplierError && <VoucherErrorBanner supplierError={supplierError} bannerType={'error'}/>}
      <ApplicationStatusOverview id={businessKey} activeTaskName={activeTaskName}/>

      <span className="mt-2 color-blue-3 text-bold font-size-24">
        Εξοπλισμός
      </span>

      <div className='mt-1'>
        <SupplierEquipmentInfo disableVoucherTabs={disableVoucherTabs} disableAction={disableAction} simulation={simulation}/>
      </div>
      
      <div className='mt-4'>
        <SupplierEquipmentCosts disableVoucherTabs={disableVoucherTabs} setDisableAction={setDisableAction} setSimulation={setSimulation}/>
      </div>

      {!isEmpty(voucherInfo?.voucher?.attachments) &&
        <div className='mt-3'>
          <span className="mt-2 color-blue-3 text-bold font-size-24">
            Έγγραφα
          </span>
          <div className='mt-3'>
            <DownloadedVoucherItems content={equipmentDocs()} docs={voucherInfo?.voucher?.attachments} />
          </div>
        </div>
      }
      {!isNil(voucherAuditorComment) &&
      <div className='mt-5'>
        <Col className="gutter-row" span={12}>
        <FormField
        label={'Σχόλιο'}
        type='textarea'
        disabled={true}
        rows={12}
        bold={true}
        value={voucherAuditorComment}
        />
        </Col>
        </div>
        }
    </div>
  );
};

export default SupplierEquipmentForm;
